var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10236",
    "data-name": "Group 10236",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.001,
    height: 17.001,
    viewBox: "0 0 17.001 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4005",
    "data-name": "Path 4005",
    d: "M0,0H17V17H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4006",
    "data-name": "Path 4006",
    d: "M14.459,5.125h2.125V6.542h-.708v7.792h.708v1.417H1V14.334h.708V6.542H1V5.125H3.125V3.708A.708.708,0,0,1,3.833,3h9.917a.708.708,0,0,1,.708.708Zm0,1.417H3.125v7.792H5.25V9.375H6.667v4.959H8.084V9.375H9.5v4.959h1.417V9.375h1.417v4.959h2.125ZM4.542,4.417v.708h8.5V4.417Z",
    transform: "translate(-0.292 -0.875)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/schoolIcon.2293db7dddf53b23f056bd1f4a3bb920.svg";
export { ForwardRef as ReactComponent };